export default __webpack_public_path__ + "static/media/typeform-light.dc1afb01.svg";